import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/brands/profile/loading';

export const Route = createFileRoute('/_private/settings/brands/$id')({
  pendingComponent: Loading,
});
